module.exports = __webpack_public_path__ + "media/unipod/icon-casting-white-c9eeb716.svg";